import script from "./ElementProgressChartLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementProgressChartLegend.vue?vue&type=script&setup=true&lang=js"

import "./ElementProgressChartLegend.vue?vue&type=style&index=0&id=604ba936&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604ba936"]])

export default __exports__